import { TEXT_PRESET_KEY } from '@optimus-web/local-tokens';
import { CaptionProps } from '../types';
import { Typography } from '../Typography';

export const Caption = (props: CaptionProps) => <Typography {...props} preset={TEXT_PRESET_KEY['100r']} />;
